import { EnumBasedItem, createEnumService } from "./base";
import type { ComplianceStatus } from "../shared/api-types/certificate";

// Re-export ComplianceStatus as the primary type
export type { ComplianceStatus };

// Deprecated: Use ComplianceStatus instead
// Kept for backward compatibility during migration
export enum CertificateStatusType {
  OK = "ok",
  EXPIRED = "expired",
  BUFFER = "buffer",
  NEVER_EXPIRE = "never_expires",
  MISSING = "missing",
}

// Constants matching ComplianceStatus values for easier migration
export const COMPLIANCE_STATUS = {
  OK: "ok" as ComplianceStatus,
  EXPIRED: "expired" as ComplianceStatus,
  BUFFER: "buffer" as ComplianceStatus,
  NEVER_EXPIRE: "never_expires" as ComplianceStatus,
  MISSING: "missing" as ComplianceStatus,
} as const;

export class CertificateStatus extends EnumBasedItem<CertificateStatusType> {}
const certificateStatusService = createEnumService(CertificateStatusType, CertificateStatus);

export default certificateStatusService;
